export default "__VITE_ASSET__c0d8c894__"